import { IncludedKeywordCategoryRequestCode } from '@doda/api-client/aspida/@types';

/**
 * クエリパラメータからキーワードを取得
 * @param query クエリパラメータ
 * @returns キーワード
 */
export const getKeyWordQuery = (query: string | undefined) => {
  if (!query) return [];

  return query.split(',');
};

/**
 * クエリパラメータからカテゴリーのコード値を取得
 * @param query クエリパラメータ
 * @returns カテゴリー
 */
export const getCategoryQuery = (
  query: string | undefined
): IncludedKeywordCategoryRequestCode => {
  if (!query) return '1';

  return (query === '9' ? '5' : query) as IncludedKeywordCategoryRequestCode;
};
